'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'binary';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'e33b';
var svgPathData = ['M0 0L0 224 192 224 192 0 0 0zM64 64l64 0 0 96-64 0 0-96zM192 288l0 224 192 0 0-224-192 0zm64 64l64 0 0 96-64 0 0-96z', 'M256 0l-32 0 0 64 48 0 0 96-48 0 0 64 160 0 0-64-48 0 0-160-80 0zM32 288l-32 0 0 64 48 0 0 96-48 0 0 64 160 0 0-64-48 0 0-160-80 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBinary = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;